import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Button ,NavDropdown} from 'react-bootstrap';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import brandLogo from '../../assets/icons/Agilisium new logo .png';
import { useSelector } from 'react-redux';

function AdminHubNavBar() {
  const [show, setShow] = useState(false);
      const [activeDropdown, setActiveDropdown] = useState(null);
  
  const [activeLink, setActiveLink] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();
  const authState = useSelector((state) => state.authUser);
  const userRoles = authState?.userRoles || [];
  const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);
  const role_id = authState?.profile?.role?.role_id;

  useEffect(() => {
    if (location.pathname === '/adminHub') {
      setActiveLink('home');
    }
  }, [location]);

  const handleClose = (link) => {
    setShow(false);
    setActiveLink(link);
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="bg-body-tertiary p-0"
        expanded={show}
        style={{ position: 'fixed', width: '100%', zIndex: '999' }}
      >
        <Container
          fluid
          style={{ background: '#FFF' }}
          className="bg-white p-1 border border-gray-400"
        >
          {/* Brand Logo */}
          <Navbar.Brand
            className="brand"
            onClick={() => {
              navigate('/adminHub');
              handleClose('home');
            }}
          >
            <img
              src={brandLogo}
              alt="brand"
              style={{
                top: '19px',
                left: '48px',
                height: '58px',
                opacity: '1',
              }}
            />
          </Navbar.Brand>

          {/* Mobile Toggle */}
          <Navbar.Toggle
            aria-controls="adminHubNavbarScroll"
            onClick={() => setShow(!show)}
          />

          {/* Navbar Links */}
          <Navbar.Collapse id="adminHubNavbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link
                as={NavLink}
                to="/adminHub"
                className={`px-4 navHeader ${activeLink === 'home' ? 'active' : ''}`}
                onClick={() => handleClose('home')}
              >
                Home
              </Nav.Link>
                        {(hasRole(6) || hasRole(15)) && <NavDropdown
                                title={hasRole(6) ? "Super Admin" : "Admin"}
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageSeats"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}

                                >
                                    Manage Seats
                                </NavDropdown.Item>
                                
                            </NavDropdown>}

            </Nav>
          </Navbar.Collapse>


          {/* Button to Go Back */}
          <Navbar.Brand className="brand" onClick={() => navigate('/')}>
            <Button className="backtohomebtn">Go to Agilisium Page</Button>
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminHubNavBar;
